module.exports = __webpack_public_path__ + "img/img_index_scene_guanli@2x.84c9a68a.png";